import React from 'react';
import { Icon } from '../../../../components';
import { DropdownMenuConfig } from '../types/dropdownTypes';
import { SubmenuItemComponent } from './SubmenuItem';
import { useDropdownMenu } from '../hooks/useDropdownMenu';

interface DropdownMenuProps {
  config: DropdownMenuConfig;
  isActive: boolean;
  onNavigate: (path: string) => void;
  sidebarCollapsed: boolean;
  classNameForListItems: string;
  currentPath: string;
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
  config,
  isActive,
  onNavigate,
  sidebarCollapsed,
  classNameForListItems,
  currentPath
}) => {
  const dropdown = useDropdownMenu();
  
  // Filter items that user has permission to view
  const accessibleItems = config.items.filter(item => item.permission);

  // If no accessible items, don't render anything
  if (accessibleItems.length === 0) {
    return null;
  }

  const handleItemClick = (path: string) => {
    onNavigate(path);
    dropdown.setIsOpen(false);
  };

  const isItemActive = (item: any) => {
    const pattern = item.pathPattern || item.id;
    return currentPath.split('/')[1].includes(pattern);
  };

  return (
    <>
      <div
        ref={dropdown.dropdownRef}
        className="w-100 sidebar-dropdown-wrapper"
        onMouseEnter={dropdown.handlers.onMouseEnter}
        onMouseLeave={dropdown.handlers.onMouseLeave}
      >
        <div
          className={`list-group-item list-group-item-action text-light font-bold border-bottom-0 py-3 px-1 ${classNameForListItems}${isActive ? ' active' : ''}`}
          style={{ textDecoration: 'none', cursor: 'pointer' }}
        >
          {sidebarCollapsed ? (
            <div className="d-flex flex-column align-items-center">
              <Icon icon={config.icon} size="lg" className="pb-2" />
              <span>{config.title}</span>
            </div>
          ) : (
            <div className="d-flex justify-content-between align-items-center px-2">
              <div className="d-flex align-items-center">
                <div className="pe-1" style={{ width: '36px', textAlign: 'center' }}>
                  <Icon icon={config.icon} size="lg" />
                </div>
                <span className="ml-2">{config.title}</span>
              </div>
            </div>
          )}
        </div>
      </div>

      {dropdown.isOpen && (
        <div
          ref={dropdown.menuRef}
          className="sidebar-dropdown-menu-fixed"
          style={{
            position: 'fixed',
            top: `${dropdown.position.top}px`,
            left: `${dropdown.position.left}px`,
            zIndex: 2000
          }}
          onMouseEnter={dropdown.handlers.onMenuMouseEnter}
          onMouseLeave={dropdown.handlers.onMenuMouseLeave}
        >
          {accessibleItems.map(item => (
            <SubmenuItemComponent
              key={item.id}
              item={item}
              isActive={isItemActive(item)}
              onClick={() => handleItemClick(item.path)}
            />
          ))}
        </div>
      )}
    </>
  );
};
